<template>
  <page-outline :title="$t('Webheader.tpp_client')">
    <template slot="pageContent">
      <b-row class="pb-3 no-gutter">
        <back-button :returnUrl="returnUrl"/>
      </b-row>
      <spinner v-if="activateSpinner"></spinner>
      <form-accordion v-else :title="$t('administration.tpp_client.tpp_client_informations')" :isTitleUpperCase="false">
        <b-row class="form-group">
          <b-col cols="6" class="form-group" v-if="hasSuperAdminView">
            <form-write-group-label-input v-if="isEditable" isMandatory
              inputType="listeSelect"
              :inputLabel="$t('administration.country')">
              <select autocomplete="off" :aria-label="$t('administration.country')" class="form-control h-30px pr-4" id="sel4" readonly v-model="tppClient.idCountry">
                <option disabled value="">{{ $t('administration.countries.select_country') }}</option>
                <option v-for="country in activableCountries" :key="'select-country-' + country.idCountry"
                  :value="country.idCountry">{{ country.name }}</option>
              </select>
            </form-write-group-label-input>
            <form-read-group-label-input v-else :inputValue="tppClient.countryName" isMandatory
              :inputLabel="$t('administration.country')">
            </form-read-group-label-input>
          </b-col>
        </b-row>
        <b-row class="form-group">
          <b-col cols="6" class="form-group">
            <form-write-group-label-input v-if="isEditable" v-model="tppClient.ClientId" isMandatory
              :inputLabel="$t('administration.tpp_client.client_id')">
            </form-write-group-label-input>
            <form-read-group-label-input v-else :inputValue="tppClient.ClientId" isMandatory
              :inputLabel="$t('administration.tpp_client.client_id')">
            </form-read-group-label-input>
          </b-col>
          <b-col cols="6" class="form-group">
            <form-write-group-label-input v-if="isEditable" v-model="tppClient.Label" isMandatory
              :inputLabel="$t('administration.tpp_client.label')">
            </form-write-group-label-input>
            <form-read-group-label-input v-else :inputValue="tppClient.Label" isMandatory
              :inputLabel="$t('administration.tpp_client.label')">
            </form-read-group-label-input>
          </b-col>
          <b-col cols="6" class="form-group">
            <form-write-group-label-input v-if="isEditable" v-model="tppClient.MemberId" isMandatory
              :inputLabel="$t('administration.tpp_client.tpp_member_id')">
            </form-write-group-label-input>
            <form-read-group-label-input v-else :inputValue="tppClient.MemberId" isMandatory
              :inputLabel="$t('administration.tpp_client.tpp_member_id')">
            </form-read-group-label-input>
          </b-col>
          <b-col cols="6" class="form-group">
            <label for="language_select" v-if="isEditable" class="">
              {{ $t('administration.tpp_client.language') }}
            </label>
            <select id="language_select" autocomplete="off" v-if="isEditable" class="form-control" v-model="tppClient.Language">
              <option :disabled="id === '-1'" :value="undefined">{{ $t('administration.tpp_client.language_select') }}</option>
              <option v-for="code in languageList" :key="code" :value="code">{{code}} - {{ $t('common.language_list.'+code) }}</option>
            </select>
            <form-read-group-label-input v-else :inputValue="tppClient.Language" isMandatory
              :inputLabel="$t('administration.tpp_client.language')">
            </form-read-group-label-input>
          </b-col>
          <b-col cols="6" class="form-group">
            <label for="tpp-active" class="">
              {{ $t('administration.tpp_client.active') }}
              <span class="color-red">* </span>
            </label>
            <select id="tpp-active" required autocomplete="off" class="form-control" v-if="isEditable" v-model="tppClient.Active">
              <option :value="1">{{$t('common.yes_label')}}</option>
              <option :value="0">{{$t('common.no_label')}}</option>
            </select>
            <div id="tpp-active" v-else>
              <i v-if="tppClient.Active === 1" class="fa-light fa-check btn btn-icon btn-icon-green"></i>
              <i v-else class="fa-duotone fa-xmark btn btn-icon btn-icon-red p-0 min-h-auto"></i>
            </div>
          </b-col>
        </b-row>
      </form-accordion>
      <form-accordion v-if="!activateSpinner" title="Redirect mode" :isTitleUpperCase="false">
        <b-row>
          <b-col cols="6" class="form-group">
            <form-write-group-label-input v-if="isEditable" v-model="tppClient.RedirectURL" isMandatory
              :inputLabel="$t('administration.tpp_client.tpp_redirect_url')">
            </form-write-group-label-input>
            <form-read-group-label-input v-else :inputValue="tppClient.RedirectURL" isMandatory
              :inputLabel="$t('administration.tpp_client.tpp_redirect_url')">
            </form-read-group-label-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <div class="form-group">
              <form-write-group-label-input v-if="isEditable" v-model="tppClient.EmailTemplate"
                :inputLabel="$t('administration.tpp_client.email_template')">
                <b-button :aria-label="labelEmailParams" slot="label-slot" variant="tertiary" class="config-buttons-title min-h-auto ml-3" @click="setParams(0)">{{ labelEmailParams }}</b-button>
              </form-write-group-label-input>
              <form-read-group-label-input v-else :inputValue="tppClient.EmailTemplate"
                :inputLabel="$t('administration.tpp_client.email_template')">
                <b-button :aria-label="labelEmailParams" slot="label-slot" variant="tertiary" class="config-buttons-title min-h-auto ml-3" @click="setParams(0)">{{ labelEmailParams }}</b-button>
              </form-read-group-label-input>
            </div>
          </b-col>
          <b-col cols="6">
            <div class="form-group">
              <form-write-group-label-input v-if="isEditable" v-model="tppClient.SMSTemplate"
                :inputLabel="$t('administration.tpp_client.sms_template')" >
                <b-button :aria-label="labelSMSParams" slot="label-slot" variant="tertiary" class="config-buttons-title min-h-auto ml-3" @click="setParams(1)">{{ labelSMSParams }}</b-button>
              </form-write-group-label-input>
              <form-read-group-label-input v-else :inputValue="tppClient.SMSTemplate"
                :inputLabel="$t('administration.tpp_client.sms_template')">
                <b-button :aria-label="labelSMSParams" slot="label-slot" variant="tertiary" class="config-buttons-title min-h-auto ml-3" @click="setParams(1)">{{ labelSMSParams }}</b-button>
              </form-read-group-label-input>
            </div>
          </b-col>
        </b-row>
      </form-accordion>
      <b-row class="justify-content-end no-gutter">
        <b-button variant="primary" v-if="formMode === 'edit' && mode !== 'add'"
          class="mx-3"
          @click="switchMode('view')">
          <span>{{ $t('common.cncl') }}</span>
        </b-button>
        <b-button variant="primary" v-if="canEdit && formMode !== 'edit' && mode !== 'add'"
          class="mx-3"
          @click="switchMode('edit')">
          <span>{{ $t('administration.edit') }}</span>
        </b-button>
        <b-button variant="primary" v-if="canDelete && formMode !== 'edit' && mode !== 'add'"
          class="mx-3" @click="deleteTPPClient">
          <i class="fa-light fa-trash"></i>
          <span>{{ $t('rights.delete') }}</span>
        </b-button>
        <b-button variant="primary" v-if="formMode === 'edit' && mode !== 'add'"
          class="mx-3" @click="editTPPClient">
          <i class="fa-light fa-save"></i>
          <span>{{$t('common.sve')}}</span>
        </b-button>
        <b-button variant="primary" v-if="mode === 'add'"
          class="mx-3" @click="addTPPClient">
          <i class="fa-light fa-save"></i>
          <span>{{$t('common.sve')}}</span>
        </b-button>
      </b-row>
    </template>
  </page-outline>
</template>

<script>

import PageOutline from '@/components/common/PageOutline.vue'

import Spinner from '@/components/common/spinner.vue'

import backButton from '@/components/common/backButton.vue'
import FormAccordion from '@/components/common/FormAccordion.vue'
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'

import _ from 'lodash'

import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'

export default {
  name: 'TPPForm',
  components: {
    'back-button': backButton,
    'page-outline': PageOutline,
    'spinner': Spinner,
    'form-accordion': FormAccordion,
    'form-read-group-label-input': formReadGroupLabelInput,
    'form-write-group-label-input': formWriteGroupLabelInput
  },
  props: {
    mode: {
      type: String,
      default: 'add'
    },
    id: {
      type: String,
      default: '-1'
    }
  },
  data : () => {
    return {
      activateSpinner: false,
      EmailParamsArray: [],
      formMode: 'add', // add, edit, view
      paramsKeyList: [
        '<url>',
        '<amount>',
        '<debtor_name>',
        '<creditor_name>',
        '<remittance_information>'
      ],
      returnUrl: '/tpp_client/list',
      SMSParamsArray: [],
      tppClient: {},
      originalDetails: {},
      redirectURLMode: '0'
    }
  },
  computed: {
    activableCountries() {
      let result = Object.entries(this.$engine.rights.getCountries()).map(([key, value]) => ({ idCountry: Number(key), ...value }))
      return result
    },
    canDelete () {
      return this.$engine.rights.rightIs('tpp_client_supprimer', true)
    },
    canEdit () {
      return this.$engine.rights.rightIs('tpp_client_editer', true)
    },
    hasSuperAdminView () {
      return !this.$engine.rights.getCurrentCountry().idCountry
    },
    isEditable () {
      return ['add', 'edit'].includes(this.formMode)
    },
    labelEmailParams () {
      return this.isEditable ? this.$i18n.t('administration.tpp_client.email_parameters_set') : this.$i18n.t('administration.tpp_client.email_parameters')
    },
    labelSMSParams () {
      return this.isEditable ? this.$i18n.t('administration.tpp_client.sms_parameters_set') : this.$i18n.t('administration.tpp_client.sms_parameters')
    },
    languageList () {
      return ['CS','DE','EN','ES','FR','HU','IT','NL','PL','PT','RO','SL']
    }
  },
  created () {
    let that = this
    this.$bus.$on('config-set-json-params', e => {
      if (e.type === 0) {
        that.EmailParamsArray = _.cloneDeep(e.params)
      } else if (e.type === 1) {
        that.SMSParamsArray = _.cloneDeep(e.params)
      }
    })
    if (this.mode === 'details') {
      this.formMode = 'view'
      this.originalDetails = {...this.$engine.administration.tppclient.clickedClient}
      this.tppClient = {...this.originalDetails}
      if (!this.tppClient.Active) {
        this.tppClient.Active = 0
      }
      this.$engine.administration.tppclient.clickedClient = {}
    } else {
      this.tppClient.Active = 1
    }
    this.redirectURLMode = this.tppClient.redirectURL ? '0' :
      (
        this.tppClient.EmailTemplate ||
        this.tppClient.EmailParameters ||
        this.tppClient.SMSTemplate ||
        this.tppClient.SMSParameters
      ) ? '1' : '0'
      if (this.tppClient.EmailParameters) {
        this.EmailParamsArray = this.tppClient.EmailParameters.split(';').map(param => ({
          key: param.split('=')[0].replaceAll('#PV#', ';').replaceAll('#EQ#', '='),
          type: that.paramsKeyList.includes(param.split('=')[1]) ? param.split('=')[1] : '',
          value: param.split('=')[1] ? param.split('=')[1].replaceAll('#PV#', ';').replaceAll('#EQ#', '=') : ''
        }))
      }
      if (this.tppClient.SMSParameters) {
        this.SMSParamsArray = this.tppClient.SMSParameters.split(';').map(param => ({
          key: param.split('=')[0].replaceAll('#PV#', ';').replaceAll('#EQ#', '='),
          type: that.paramsKeyList.includes(param.split('=')[1]) ? param.split('=')[1] : '',
          value: param.split('=')[1] ? param.split('=')[1].replaceAll('#PV#', ';').replaceAll('#EQ#', '=') : ''
        }))
      }
  },
  methods: {
    addTPPClient () {
      let that = this
      if (!this.formValidator()) {
        return
      }
      that.activateSpinner = true
      let params = {
        clientId: this.tppClient.ClientId,
        label: this.tppClient.Label,
        TPPMemberId: this.tppClient.MemberId,
        TPPRedirectURL: this.tppClient.RedirectURL,
        language: this.tppClient.Language,
        active: this.tppClient.Active,
        EmailTemplate: this.tppClient.EmailTemplate,
        EmailParameters: this.EmailParamsArray.map(elem => elem.key.replaceAll(';', '#PV#').replaceAll('=', '#EQ#') + '=' + elem.value.replaceAll(';', '#PV#').replaceAll('=', '#EQ#')).join(';'),
        SMSTemplate: this.tppClient.SMSTemplate,
        SMSParameters: this.SMSParamsArray.map(elem => elem.key.replaceAll(';', '#PV#').replaceAll('=', '#EQ#') + '=' + elem.value.replaceAll(';', '#PV#').replaceAll('=', '#EQ#')).join(';')
      }
      if (this.hasSuperAdminView) {
        params.idCountry = this.tppClient.idCountry
      }
      this.$engine.administration.tppclient.create(params)
      .then(() => {
        that.$f7.modal({
          title: that.$t('administration.tpp_client.tpp_client_added'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                loadPage(that, {url: '/tpp_client/list'})
                return
              }
            }
          ]
        })
        that.activateSpinner = false
      })
      .catch(err => {
        that.activateSpinner = false
        errorMessageAlert(err, that)
      })
    },
    deleteTPPClient () {
      let that = this
      that.$f7.modal({
        title: that.$t('administration.tpp_client.tpp_client_delete_confirmation'),
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              that.activateSpinner = true
              that.$engine.administration.tppclient.delete(that.id)
              .then(() => {
                that.$f7.modal({
                  title: that.$t('administration.tpp_client.tpp_client_deleted'),
                  buttons: [
                    {
                      text: 'OK',
                      onClick: function () {
                        loadPage(that, {url: '/tpp_client/list'})
                        return
                      }
                    }
                  ]
                })
                that.activateSpinner = false
              })
              .catch(err => {
                that.activateSpinner = false
                errorMessageAlert(err, that)
              })
            }
          },
          {
            text: that.$t('common.cncl'),
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    editTPPClient () {
      let that = this
      this.tppClient.EmailParameters = this.EmailParamsArray.map(elem => elem.key.replaceAll(';', '#PV#').replaceAll('=', '#EQ#') + '=' + elem.value.replaceAll(';', '#PV#').replaceAll('=', '#EQ#')).join(';')
      this.tppClient.SMSParameters = this.SMSParamsArray.map(elem => elem.key.replaceAll(';', '#PV#').replaceAll('=', '#EQ#') + '=' + elem.value.replaceAll(';', '#PV#').replaceAll('=', '#EQ#')).join(';')

      that.activateSpinner = true
      this.$engine.administration.tppclient.edit(this.tppClient)
      .then(() => {
        that.$f7.modal({
          title: that.$t('administration.tpp_client.tpp_client_edited'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                loadPage(that, {url: '/tpp_client/list'})
                return
              }
            }
          ]
        })
        that.activateSpinner = false
      })
      .catch(err => {
        that.activateSpinner = false
        errorMessageAlert(err, that)
      })
    },
    formValidator () {
      if (!this.tppClient.ClientId) {
        this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('administration.tpp_client.client_id')}))
        return false
      }
      if (!this.tppClient.Label) {
        this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('administration.tpp_client.label')}))
        return false
      }
      if (!this.tppClient.MemberId) {
        this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('administration.tpp_client.tpp_member_id')}))
        return false
      }
      return true
    },
    setParams (type) {
      this.$bus.$emit('popup-set-json-params', { params: _.cloneDeep(type === 0 ? this.EmailParamsArray : this.SMSParamsArray), type: type, readonly: !this.isEditable })
    },
    switchMode (newMode) {
      this.formMode = newMode
    }
  }
}

</script>
